module.exports = __webpack_public_path__ + "img/nodejs.c079a3e3.png";